(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('bcmBiaProfileActivityProcessController', Controller);

    Controller.$inject = ['$scope', 'adminReferenceDataService'];

    function Controller($scope, adminReferenceDataService) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        $scope.domains = [];
        $scope.searchText = '';
        $scope.ctrlCtxt.isLoading = true;

        init();

        // Toggle domain expand/collapse
        $scope.toggleDomain = function (domain) {
            domain.isExpanded = !domain.isExpanded;
        };

        // Toggle process selection
        $scope.toggleProcess = function (process) {
            if (process.isSelected) {
                // Remove
                _.remove($scope.selectedProcesses, { LookupAttributeValueID: process.LookupAttributeValueID });
                process.isSelected = false;
            } else {
                // Add
                $scope.selectedProcesses.push(process);
                process.isSelected = true;
            }
        };

        // Remove from selected list
        $scope.removeProcess = function (process) {
            _.remove($scope.selectedProcesses, { LookupAttributeValueID: process.LookupAttributeValueID });
            process.isSelected = false;
        };

        // Filter processes by search text
        $scope.matchesSearch = function (process) {
            if (!$scope.searchText) return true;
            var search = $scope.searchText.toLowerCase();
            return (process.TitleEN && process.TitleEN.toLowerCase().indexOf(search) !== -1)
                || (process.TitleFR && process.TitleFR.toLowerCase().indexOf(search) !== -1);
        };

        // Check if domain has any visible processes
        $scope.domainHasVisibleProcesses = function (domain) {
            if (!$scope.searchText) return true;
            return _.some(domain.processes, function (p) {
                return $scope.matchesSearch(p);
            });
        };

        // Save
        $scope.saveChanges = function () {
            var ids = _.map($scope.selectedProcesses, 'LookupAttributeValueID');
            $scope.onActivityProcessSave(ids);
        };

        // Cancel
        $scope.onModalClose = function () {
            $scope.close();
        };

        function init() {
            // Parse current selection
            var currentIds = parseActivityProcesses($scope.boxModel.ActivityProcesses);
            $scope.selectedProcesses = [];

            adminReferenceDataService
                .getLookupAttributeValues('BIAResponsibility')
                .then(function (lookupAttributes) {
                    if (!lookupAttributes.BCMActivityProcess) {
                        $scope.ctrlCtxt.isLoading = false;
                        return;
                    }

                    var allValues = lookupAttributes.BCMActivityProcess.LookupAttributeValues || [];

                    // Separate Level-1 (domains) and Level-2 (processes)
                    var level1 = _.filter(allValues, function (v) { return !v.LookupAttributeValueRelationID; });
                    var level2 = _.filter(allValues, function (v) { return !!v.LookupAttributeValueRelationID; });

                    // Group processes by parent
                    var processesByParent = _.groupBy(level2, 'LookupAttributeValueRelationID');

                    // Build domain tree
                    $scope.domains = _.map(_.sortBy(level1, 'Order'), function (domain) {
                        var processes = _.sortBy(processesByParent[domain.LookupAttributeValueID] || [], 'Order');

                        // Mark selected processes
                        _.each(processes, function (p) {
                            p.isSelected = _.includes(currentIds, p.LookupAttributeValueID);
                            p.domainTitleEN = domain.TitleEN;
                            p.domainTitleFR = domain.TitleFR;
                            if (p.isSelected) {
                                $scope.selectedProcesses.push(p);
                            }
                        });

                        return {
                            LookupAttributeValueID: domain.LookupAttributeValueID,
                            TitleEN: domain.TitleEN,
                            TitleFR: domain.TitleFR,
                            processes: processes,
                            isExpanded: false
                        };
                    });

                    // Auto-expand domains that have selected processes
                    _.each($scope.domains, function (domain) {
                        if (_.some(domain.processes, 'isSelected')) {
                            domain.isExpanded = true;
                        }
                    });
                })
                .catch(function () {
                    $scope.domains = [];
                })
                .finally(function () {
                    $scope.ctrlCtxt.isLoading = false;
                });
        }

        function parseActivityProcesses(raw) {
            if (!raw) return [];
            if (_.isArray(raw)) return raw;
            try { return JSON.parse(raw); }
            catch (e) { return []; }
        }
    }
})();
